/*
This information is based on the LIST FILE of the current client

 */


export class MeasurementDescription {
  number: number = 0;
  channelfull: number  = 0;
  channelnr: number  = 0;
  channela: string =  "!";
  description: string = "-";
  department: string   = "-";
}

export interface MeasurementDescriptionList {
  MeasurementDescription: MeasurementDescription[];
}

